<template>
  <div class="toolbar">
    <div class="left">
      <User />
      <Cycle class="cycle" />
      <week-cycle
        class="cycle"
        v-bind="$attrs"
      />
    </div>
    <div class="right">
      <a-button
        class="button"
        @click="switchAllOrCurrent"
      >
        {{ allOrCurrent === 'ALL' ? $t('weekly.currentRisk') : $t('weekly.all') }}
      </a-button>
      <a-popover
        v-if="uid !== UID"
        v-model:visible="exportPopoverVisible"
        trigger="click"
      >
        <template #content>
          <div>
            <a-date-picker
              v-model:value="start"
              :disabled-date="disabledStartDate"
            />
          </div>
          <div class="row">
            <a-date-picker
              v-model:value="end"
              :disabled-date="disabledEndDate"
            />
          </div>
          <div class="row">
            <a-button
              @click="exportPopoverVisible=false"
            >
              {{ $t('weekly.exportCancel') }}
            </a-button>
            <a-button
              type="primary"
              :disabled="!start || !end"
              @click="exportHandler"
            >
              {{ $t('weekly.exportConfirm') }}
            </a-button>
          </div>
        </template>
        <a-button class="button">
          {{ $t('weekly.export') }}
        </a-button>
      </a-popover>
    </div>
  </div>
</template>
<script>
import User from '@/views/OkrList/User'
import Cycle from '@/components/Cycle'
import WeekCycle from './week-cycle.vue'
import { UID } from '@/constants/my-team-weekly-custom.js'
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
export default {
  components: {
    User,
    Cycle,
    WeekCycle
  },
  props: {
    userId: {
      type: [Number, String],
      default: undefined
    },
    allOrCurrent: {
      type: String,
      default: 'ALL'
    },
    okrId: {
      type: Number,
      default: undefined
    }
  },
  emits: ['update:allOrCurrent'],
  setup (props, { emit }) {
    // 开始时间，结束时间
    const store = useStore()
    const uid = computed(() => store.state.user.uid)
    const start = ref()
    const end = ref()
    const disabledStartDate = (date) => {
      return date.isAfter(end.value)
    }
    const disabledEndDate = (date) => {
      return date.isBefore(start.value)
    }

    const exportPopoverVisible = ref(false)

    // 导出报表
    function exportHandler () {
      window.open(`/export/okr.weekly/list?okrlist_id=${props.okrId}&start_date=${start.value.format('YYYY-MM-DD')}&end_date=${end.value.format('YYYY-MM-DD')}`)
    }

    // 切换数据显示，是否显示当前风险
    function switchAllOrCurrent () {
      if (props.allOrCurrent === 'ALL') {
        emit('update:allOrCurrent', 'CURRENT')
      } else {
        emit('update:allOrCurrent', 'ALL')
      }
    }

    return {
      exportHandler,
      switchAllOrCurrent,
      start,
      end,
      disabledStartDate,
      disabledEndDate,
      UID,
      uid,
      exportPopoverVisible
    }
  }
}
</script>
<style lang="less" scoped>
.toolbar {
  padding: 16px 0 8px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cycle {
  margin-left: 40px;
}

.left {
  display: flex;
  align-items: center;
}

.button {
  margin-left: 8px;
}

.row {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
}
</style>
